import React from 'react';
import { iconSizer } from "../../../../../icons2022/iconSizer";
import { MarkupIcon16Solid } from "../../../../../icons2022/FileTypeMarkupIcon/MarkupIcon16Solid";
import { MarkupIcon20Solid } from "../../../../../icons2022/FileTypeMarkupIcon/MarkupIcon20Solid";
import { MarkupIcon24Solid } from "../../../../../icons2022/FileTypeMarkupIcon/MarkupIcon24Solid";
export var MarkupIcon = iconSizer({
  small: function small() {
    return /*#__PURE__*/React.createElement(MarkupIcon16Solid, null);
  },
  medium: function medium() {
    return /*#__PURE__*/React.createElement(MarkupIcon20Solid, null);
  },
  large: function large() {
    return /*#__PURE__*/React.createElement(MarkupIcon24Solid, null);
  }
}, 'MarkupIcon');